import { useQuery } from "@tanstack/react-query";
import { api } from "../client";
import { queryKeys } from "../query-keys";

export function useFileSelect(
  filename: string | undefined,
  target: string | undefined,
) {
  return useQuery({
    queryKey: queryKeys.file.byTargetAndName(target, filename),
    enabled: !!filename && !!target,
    queryFn: async () => {
      const res = await api.fileApi.apiFileTargetFilenameGet(
        target!,
        filename!,
        {
          responseType: "blob",
          headers: {
            Accept: "image/jpeg",
          },
        },
      );

      const blob = res.data as Blob;

      return URL.createObjectURL(blob);
    },
    staleTime: Infinity,
    gcTime: 5 * 60 * 1000,
    meta: {
      skipGlobalError: true,
    },
  });
}
